import css from "./NpcLink.module.css";

import { Link } from "react-router";
import { GameVer, tturl, useRealm } from "~/util/Lang";
import { EntityTooltip } from "../site/Tooltip";
import { Icon } from "../ui/Icon";

export type NpcLinkData = {
  type?: string | null;
  npcName: string;
  name: string | null;
  level?: number | null;
  nick: string | null;
  nickColor: "default" | "quest" | "raid";
  race?: { icon?: string };
  gver?: GameVer;
};

export function getNpcPath(props: { npc: NpcLinkData }) {
  const npc = props.npc;
  const realm = useRealm();

  return tturl(
    { lang: realm.lang, game: npc.gver ?? realm.game },
    `/npcs/${npc.npcName}`
  );
}

export function NpcLink(props: {
  showLvl?: boolean;
  showIcon?: boolean;
  npc: NpcLinkData;
  isLink?: boolean;
}) {
  const { npc } = props;
  const showLvl = props.showLvl ?? true;
  const showIcon = props.showIcon ?? false;
  const level = npc.level !== null ? `Lvl. ${npc.level}` : null;
  const isLink = props.isLink ?? true;
  const linkColor = npcNameColor({ nickColor: npc.nickColor, type: npc.type });

  const linkContent = (
    <>
      {showIcon && (
        <span className={css.icon}>
          <Icon icon={npc.race?.icon!} size={16} />
        </span>
      )}
      {npc.nick && (
        <span
          className={css.nick}
          style={{
            color: npcTitleColor({
              nickColor: npc.nickColor,
              type: npc.type,
            }),
          }}
        >
          {npc.nick}
        </span>
      )}
      <span className={css.name}>{npc.name}</span>
    </>
  );
  return (
    <span className={css.wrapper}>
      <EntityTooltip what={{ t: "npc", uname: npc.npcName }} gver={npc.gver}>
        {({ setReference, getReferenceProps }) =>
          isLink ? (
            <Link
              ref={setReference}
              to={getNpcPath({ npc })}
              {...getReferenceProps()}
              className={css.link}
              style={{ color: linkColor }}
            >
              {linkContent}
            </Link>
          ) : (
            <span
              ref={setReference}
              {...getReferenceProps()}
              className={css.link}
              style={{ color: linkColor }}
            >
              {linkContent}
            </span>
          )
        }
      </EntityTooltip>
      {showLvl && level && <span className={css.lvl}>{level}</span>}
    </span>
  );
}

export function npcTitleColor(props: {
  type?: string | null;
  nickColor?: "default" | "quest" | "raid";
}) {
  const { type, nickColor } = props;
  let color = "#b8e6ad";
  switch (nickColor) {
    case "raid":
      color = "#f35a5a";
      break;
    case "quest":
      color = "#df732c";
      break;
    default:
      color = type === "warrior" ? "#f35a5a" : "#75cd5f";
      break;
  }
  return color;
}

// export function npcTypeColor(type: string) {
//   switch (type.toLowerCase()) {
//     case "warrior":
//       return "#ff7777";
//     default:
//       return "#fff";
//   }
// }

export function npcNameColor(props: {
  type?: string | null;
  nickColor?: "default" | "quest" | "raid";
}) {
  const { type, nickColor } = props;
  let color = "#b8e6ad";
  // if (props.type === "warrior") {
  //   color = npcTypeColor(props.type);
  //   if (getTitle(props.nick) === "quest monster") {
  //     color = "#ef9d66";
  //   }
  //   if (getTitle(props.nick) === "kaboo chief") {
  //     color = "#ef9d66";
  //   }
  //   if (getTitle(props.nick) === "orc betrayer") {
  //     color = "#ef9d66";
  //   }
  // } else {
  //   color = "#b8e6ad";
  // }
  switch (nickColor) {
    case "raid":
      color = "#ff7777";
      break;
    case "quest":
      color = "#ef9d66";
      break;
    default:
      color = type === "warrior" ? "#ff7777" : "#b8e6ad";
      break;
  }
  return color;
}
